export default "__VITE_ASSET__DVxAN3fy__"